import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiCheck, FiMail, FiPackage } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber || "TV-DEMO";

  useEffect(() => {
    document.title = `Order Confirmed — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="success-page shell">
      <div className="success-mark"><FiCheck /></div>
      <p className="eyebrow">Thank you for your order</p>
      <h1>It is in good hands.</h1>
      <p className="success-lead">
        Your order <b>{orderNumber}</b> is confirmed{state?.total ? <> for a total of <b>{formatPrice(state.total)}</b></> : null}.
      </p>
      <div className="success-steps">
        <article><FiMail /><div><h2>Confirmation sent</h2><p>An order summary was sent to {state?.email || "your email address"}.</p></div></article>
        <article><FiPackage /><div><h2>Prepared within 48 hours</h2><p>We will email you again as soon as your parcel leaves our fulfilment centre.</p></div></article>
      </div>
      <div className="success-actions">
        <Link className="btn" to="/shop">Continue shopping</Link>
        <Link className="btn btn--outline" to="/contact">Contact us</Link>
      </div>
    </main>
  );
};

export default PaySuccess;
